export const RoutePutMerchflows_merchflowId_Notes = "/merchflows/:merchflowId/notes";

export interface PayloadPutMerchflows_merchflowId_Notes {
  notes: string;
}
